import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { isFolderNode } from '../../receipts/model/tree'
import { monthRangeOf } from './shifts'
import {
  shiftsCashierChosen,
  shiftsMineOnlyChosen,
  shiftsNodeToggled,
  shiftsPeriodChosen,
  shiftsPlaceChosen,
  shiftsStateChosen,
} from './shiftsSlice'
import type { ShiftsActions } from './types'

/**
 * Действия отбора раздела «Смены» для binding: `{ ...createShiftsViewActions(rid, dispatch, today), reload, openReceipts }`.
 * Перечитывание и переход в «Чеки» binding делает сам: у них кэш и окна приложения.
 */
export function createShiftsViewActions(
  resourceId: string,
  dispatch: Dispatch<UnknownAction>,
  today: string,
): Omit<ShiftsActions, 'reload' | 'openReceipts'> {
  return {
    periodChanged: (range) => dispatch(shiftsPeriodChosen({ resourceId, range })),
    monthShown: (month) => dispatch(shiftsPeriodChosen({ resourceId, range: monthRangeOf(month, today) })),
    // «Кассы без магазина» — папка, а не отбор: щелчок её только раскрывает.
    nodeChosen: (nodeId) => dispatch(isFolderNode(nodeId) ? shiftsNodeToggled({ resourceId, nodeId }) : shiftsPlaceChosen({ resourceId, place: nodeId })),
    nodeToggled: (nodeId) => dispatch(shiftsNodeToggled({ resourceId, nodeId })),
    stateChanged: (state) => dispatch(shiftsStateChosen({ resourceId, state })),
    cashierChanged: (cashier) => dispatch(shiftsCashierChosen({ resourceId, cashier })),
    mineOnlyChanged: (mineOnly) => dispatch(shiftsMineOnlyChosen({ resourceId, mineOnly })),
  }
}
